import React, { useEffect, useState } from "react";
import API from "../../services/api";

function ConsolidatedNational(props) {
  const { month, year, newReports } = props;
  const [consolidatedNationalData, setConsolidatedNationalData] = useState([]);
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month-1))

  function getDaysInMonth(year, month) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0-based index
    // If the provided year and month match the current year and month, return today's date
    if (+year === +currentYear && +month === +currentMonth) {
      return today.getDate();
    }
  
    // Otherwise, return the last day of the month
    return new Date(year, month + 1, 0).getDate();
  }
  function getStartAndEndOfMonthTimestamps(year, month) {
    // Months are zero-indexed in JavaScript (0 for January, 11 for December)
    const startDate = new Date(year, month - 1, 1); // Start of the month
    const endDate = new Date(year, month, 0); // End of the month (0th day of the next month)

    // Convert to timestamps (in seconds)
    const startTimestamp = Math.floor(startDate.getTime() / 1000);
    const endTimestamp = Math.floor(endDate.getTime() / 1000);

    return { startTimestamp, endTimestamp };
  }

  const { startTimestamp, endTimestamp } = getStartAndEndOfMonthTimestamps(
    year,
    month
  );
  const fetchData = async () => {
    try {
      let res = await API({
        url: "reports/consolidated-national",
        method: "POST",
        responseType: "json",
        data: {
          startTimestamp,
          endTimestamp,
          newReport:newReports
        },
      });
      if(res.code === 200){
        setConsolidatedNationalData(res.data)
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1); 
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + (times * 86400)
  }

  const getSpentForTimestamp = (timestamp, type)=> {
    // Find the entry for the specified timestamp in the data array
    const entry = consolidatedNationalData.find((item) => item.date === timestamp);

    if (entry) {
      if (type === "spent")
        return parseFloat(entry.totalSpent).toFixed(2);
      else if (type === "clicks") return parseInt(entry.totalClicks);
      else return parseInt(entry.totalImpressions);
    }

    // If the entry doesn't exist, return null or handle accordingly based on your use case
    return 0;
  }

  const calculateEcpm = (index)=>{
    const impressions = getSpentForTimestamp(getTimestamp(index), 'impressions')
    const spent = getSpentForTimestamp(getTimestamp(index), 'spent')
    let ecpm = (spent / impressions) * 1000;
    return !isNaN(ecpm) && ecpm !== Infinity
      ? parseFloat(ecpm).toFixed(2)
      : "-";
  }

  const calculateCTR = (index) =>{
    let impressions = getSpentForTimestamp(getTimestamp(index), "impressions");
    let clicks = getSpentForTimestamp(getTimestamp(index), "clicks");
    let ctr = (clicks / impressions) * 100;
    return ctr ? ctr.toFixed(2) : "-";
  }
  const handleCurrentDay = ()=>{
    setCurrentDay(getDaysInMonth(year, month -1))
  }

  function getColumnTotal(type) {
    let totalRevenue = 0;
    let totalClicks = 0;
    let totalImpressions = 0;
    if (consolidatedNationalData.length) {
      consolidatedNationalData.map((entry) => {
        if (type === "revenue") {
          entry.totalSpent ? totalRevenue += parseFloat(entry.totalSpent) : totalRevenue += 0;
        } else if (type === "impressions") {
          entry.totalImpressions ? totalImpressions += parseInt(entry.totalImpressions) : totalImpressions += 0;
        } else if (type === "clicks") {
          entry.totalClicks ? totalClicks += parseInt(entry.totalClicks) : totalClicks += 0;
        }
      })
      return type === "revenue" ? parseFloat(totalRevenue).toFixed(2) : type === "impressions" ? parseInt(totalImpressions) : parseInt(totalClicks)
    } else {
      return 0;
    }
  }

  const calculateAvg = (type) => {
    let ecpms = [];
    let ctrs = []
    let ecpmsSum = 0;
    let ctrsSum = 0;
    if (consolidatedNationalData.length) {
      consolidatedNationalData.map((entry) => {
        if (type === "ecpm") {
          let ecpm;
          if (entry.totalSpent && entry.totalImpressions) {
            ecpm = (parseFloat(entry.totalSpent) / parseInt(entry.totalImpressions)) * 1000
          };
          if (!isNaN(ecpm) && ecpm !== Infinity) {
            ecpms.push(ecpm);
          }
        } if (type === "ctr") {
          let ctr;
          if (entry.totalClicks && entry.totalImpressions) {
            ctr = (parseInt(entry.totalClicks) / parseInt(entry.totalImpressions)) * 100
          };
          if (!isNaN(ctr) && ctr !== Infinity) {
            ctrs.push(ctr);
          }
        }
      })
      if (type == "ecpm") {
        if (ecpms.length > 0) {
          ecpms.map((item) => {
            ecpmsSum += item;
          })
        }
        else {
          return 0;
        }
      } else if (type == "ctr") {
        if (ctrs.length > 0) {
          ctrs.map((item) => {
            ctrsSum += item;
          })
        } else {
          return 0;
        }
      }
      return type === "ecpm" ? (parseFloat(ecpmsSum) / ecpms.length).toFixed(2) : (parseFloat(ctrsSum) / ctrs.length).toFixed(2);
    } else { return 0; }
  }

  useEffect(() => {
    fetchData();
    handleCurrentDay()
  }, [month, year, newReports]);
  return (
    <div className="report-image">
      <div className="overflow-x-auto responsive-table">
        <table
          className="table table-bordered report-table"
          id="consolidated-report"
        >
          <thead>
            <tr id="national-child1">
              <td colSpan={12}>
                <h4>National - Overall Report</h4>
              </td>
            </tr>
            <tr id="national-child2">
              <td colSpan={12}>
                <h4>
                  {" "}
                  National CPM Consolidated Delivery report - {} {}
                </h4>
              </td>
            </tr>
            <tr id="#national-child3">
              <th>Date</th>
              <th>Revenue</th>
              <th>Impressions</th>
              <th>Clicks</th>
              <th>eCPM</th>
              <th>CTR</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: currentDay }, (_, index1) => (
              <tr key={index1}>
                <td>{`${index1 + 1}/${month}/${year}`}</td>
                <td>{getSpentForTimestamp(getTimestamp(index1), "spent")}</td>
                <td>{getSpentForTimestamp(getTimestamp(index1), "impressions")}</td>
                <td>{getSpentForTimestamp(getTimestamp(index1), "clicks")}</td>
                <td>{calculateEcpm(index1)}</td>
                <td>{calculateCTR(index1)}</td>
              </tr>
            ))}
            <tr>
              <td>Total</td>
              <td>{getColumnTotal("revenue")}</td>
              <td>{getColumnTotal("impressions")}</td>
              <td>{getColumnTotal("clicks")}</td>
              <td>{calculateAvg("ecpm")}</td>
              <td>{calculateAvg("ctr")}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ConsolidatedNational;
